import {
  EllipsisVerticalIcon,
  HeartHandshakeIcon,
  MessageCircleQuestionIcon,
  MessageSquareShareIcon,
  SendIcon,
  StarsIcon,
} from 'lucide-react';

import { Button } from '../../../../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from '../../../../ui/dropdown-menu';

export function BidDetailsOptionsMenu() {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="outline">
          <EllipsisVerticalIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuGroup>
          <DropdownMenuItem disabled>
            <StarsIcon />
            Keep me in the winning range
            <DropdownMenuShortcut>⇧⌘P</DropdownMenuShortcut>
          </DropdownMenuItem>
          <DropdownMenuItem disabled>
            <StarsIcon />
            Find me similar devices
            <DropdownMenuShortcut>⇧+</DropdownMenuShortcut>
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />

        <DropdownMenuItem disabled>
          <MessageSquareShareIcon />
          Share via Link
        </DropdownMenuItem>
        <DropdownMenuItem disabled>
          <SendIcon />
          Send to Email
        </DropdownMenuItem>

        <DropdownMenuSeparator />

        <DropdownMenuItem disabled>
          <MessageCircleQuestionIcon />
          Need Support
        </DropdownMenuItem>
        <DropdownMenuItem disabled title="Article coming soon">
          <HeartHandshakeIcon />
          Help / Bidding Explained
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
